<!-- footbar start-->
<div class="container-fluid" id="footer">
  <div class="row">
    <div class="container">
      <div class="column-list">
        <div class="column info-column">
          <p class="title">GET IN TOUCH</p>
          <li>
            <span class="svg-icon"><i class="flaticon-placeholder-1" ></i></span>
            <p class="location">
              <a href="{{(data | async)?.restaurant_data?.map_url ? (data | async)?.restaurant_data?.map_url : 'https://www.google.com/maps/search/'+restaurant_address}}" title="{{restaurant_address_for_view}}" target="_blank">{{restaurant_address_for_view}}</a>
            </p>
          </li>
          <li class="contacts" *ngIf="(data | async)?.restaurant_data?.business_tel && (data | async)?.restaurant_data?.business_tel !==''">
            <span class="svg-icon"><i class="flaticon-phone" ></i></span>
            <p>
              <span *ngFor="let item of (data | async)?.restaurant_data?.business_tel | split">
                <a href="tel:{{item.trim()}}" title="{{item.trim()}}">{{item.trim()}}</a><br>
              </span>
            </p>
          </li>
          <li class="email" *ngIf="(data | async)?.restaurant_data?.email && (data | async)?.restaurant_data?.email !==''">
            <span class="svg-icon"><i class="flaticon-envelope" ></i></span>
            <p>
              <a href="mailto:{{(data | async)?.restaurant_data?.email}}" title="{{(data | async)?.restaurant_data?.email}}">{{(data | async)?.restaurant_data?.email}}</a>
            </p>
          </li>
          <p class="social-btn-wrapper mb-3" *ngIf="(data | async)?.restaurant_data?.social_media && (data | async)?.restaurant_data?.social_media?.length > 0">
            <a *ngFor="let item of (data | async)?.restaurant_data?.social_media" title="{{item.media_name}}" href="{{item?.link}}" target="_blank" class="btn {{item.media_name}}">
              <span class="social-icon"><img src="../../.././../assets/social-icon/{{item.media_name}}.svg" alt="{{item.media_name}}"></span>
            </a>
          </p>
        </div>
        
        <div class="column schedule-column">
          <p class="title">Opening Hours</p>
          <ng-container *ngIf="footerScheduleRaw?.length > 0">
            <li class="schedules active">
              <ng-container>
                <span class="day">Today</span>
                <span class="time">
                  <li>
                      <span class="today-time text-lowercase" *ngFor="let schedule of getFooterTodayScheduleItems()"><strong>{{ schedule }}</strong></span>
                    </li>
                </span>
              </ng-container>
            </li>
          </ng-container>

          <li class="more-schedule">

            <div (click)="showScheduleClick()" class="d-flex align-items-center justify-content-between mb-2" data-toggle="collapse" href="#multiCollapseExample1"
            role="button" aria-expanded="false" aria-controls="multiCollapseExample1">
              <span class="">Show {{isShowScheduleClick ? 'less' : 'all'}}</span>
              <span class="icon {{isShowScheduleClick ? 'icon-up' : ''}} ">
                <i class="flaticon-arrow-down-sign-to-navigate" ></i>
              </span>
            </div>
            

            <div class="collapse multi-collapse {{isShowScheduleClick ? 'collapse-show' : ''}}" id="multiCollapseExample1">
              <div class="">
                <ng-container *ngFor="let day of footerSchedule">
                  <li class="schedules">
                    <ng-container>
                      <span class="day">{{day.dayName}}</span>
                      <span class="time">
                        <ng-container *ngIf="day?.status === 'open' && (day.shift?.length > 0 || day?.label); else showClosed">
                          <ng-container *ngIf="day?.label; else showShiftTimes">
                            <li *ngFor="let label of getFooterScheduleLabelItems(day.label)">
                              <span class="text-lowercase">{{label}}</span>
                            </li>
                          </ng-container>
                          <ng-template #showShiftTimes>
                            <li *ngFor="let time of day.shift">
                              <span class="text-lowercase">{{time.openingTime}} - {{time.closingTime}}</span>
                            </li>
                          </ng-template>
                        </ng-container>
                        <ng-template #showClosed>
                          <span>Closed</span>
                        </ng-template>
                      </span>
                    </ng-container>
                  </li>
                </ng-container>
              </div>
            </div>

          </li>
        </div>
        
        <div class="column cuisine-column">
          <p class="title">Quick Links</p>
          <li *ngIf="(data | async)?.restaurant_content?.order_online_page?.is_active">
            <a class="link" title="Order" [routerLink]="['/order-online']">Order</a>
          </li>
          <li *ngIf="(data | async)?.restaurant_content?.booking_page?.is_active">
            <a class="link" title="Reservation" [routerLink]="['/reservation']">Reservation</a>
          </li>
          <li *ngIf="(data | async)?.restaurant_content?.deals_page?.is_active">
            <a class="link" title="Deals" [routerLink]="['/deals']">Deals</a>
          </li>
          <li *ngIf="(data | async)?.restaurant_content?.review_page?.is_active">
            <a class="link" title="Review" [routerLink]="['/reviews']">Review</a>
          </li>
          <li><a class="link" title="Terms & Conditions" [routerLink]="['/terms-conditions']">Terms & Conditions</a></li>
          <li><a class="link" title="Privacy Policy" [routerLink]="['/privacy-policy']">Privacy Policy</a></li>
        </div>
        <div class="column delivery-column">
          <ng-container *ngIf="(data | async)?.restaurant_data?.is_delivery && areas?.length > 0">
            <p class="title">Delivery Areas</p>
            <li class="areas" *ngFor="let item of areas | slice:0:2;">
              <ng-container *ngIf="item?.is_radius">
                <span *ngIf="item?.delivery_charge === 0">Free Delivery</span>
                <span *ngIf="item?.delivery_charge > 0">Delivery Charge {{item.delivery_charge |  CustomCurrency}}</span>
                : Up-to {{item?.maximum_delivery_area}} mile radius
              </ng-container>
              <ng-container *ngIf="item?.is_radius === false">
                {{item?.area_name.toUpperCase()}} {{item?.area_postcode.toUpperCase()}} -
                <span *ngIf="item?.delivery_charge > 0"> Delivery Charge {{item?.delivery_charge |  CustomCurrency}}</span>
                <span *ngIf="item?.delivery_charge === 0"> Free Delivery</span>
              </ng-container>
            </li>
            <li *ngIf="areas?.length >= 3">
              <button type="button" class="btn btn-link p-0" data-toggle="modal" data-target="#deliveryAreas">
                See More <span class="icon end"><i class="flaticon-fast-forward-double-right-arrows-symbol"></i></span>
              </button>
            </li>
            <legend class="divider"></legend>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- footbar end-->

<!-- footer start-->
<div class="container-fluid" id="footbar">

  <div *ngIf="(data | async)?.restaurant_data?.platform === 0; then template1"></div>
    <div *ngIf="(data | async)?.restaurant_data?.platform === 1; then template2"></div>
    <div *ngIf="(data | async)?.restaurant_data?.platform === 2; then template3"></div>


    <ng-template #template1>
      <div class="container">
        <span class="copyright-text">
          Urban-Eatery Partner Restaurant. ©{{today | date: 'yyyy'}} <a href="http://urban-eatery.co.uk/" title="urban-eatery">urban-eatery.co.uk</a>. All Rights Reserved
        </span>
        <span class="links">
          <a href="http://urban-eatery.co.uk/" title="Become a partner restaurant" target="_blank">Become a partner restaurant</a>
        </span>
      </div>
    </ng-template>

    <ng-template #template2>
      <div class="container">
        <span class="copyright-text">
          Copyright ©{{today | date: 'yyyy'}} <a href="http://urban-eatery.co.uk/" title="urban-eatery">urban-eatery.co.uk</a>. All Rights Reserved
        </span>
      </div>
    </ng-template>

    <ng-template #template3>
      <div class="container">
        <span class="copyright-text">
          Copyright ©{{today | date: 'yyyy'}} <strong><a class="text-decoration-underline" routerLink="/">{{(data | async)?.restaurant_data?.restaurant_name}}</a></strong>. All Rights Reserved
        </span>
      </div>
    </ng-template>

</div>
<!-- footer end-->


<div class="modal fade" id="deliveryAreas" tabindex="-1" role="dialog" aria-labelledby="deliveryAreasTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable sliding-modal" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="deliveryAreasTitle">Delivery Areas</h5>
        <button type="button" class="btn btn-sm btn-outline-danger rounded-circle" data-dismiss="modal">
          <span class="icon"><i class="flaticon-unchecked" ></i></span>
        </button>
      </div>
      <div class="modal-body">
        <ul class="list-group list-group-flush">
          <li class="list-group-item px-0" *ngFor="let item of areas">
            <span *ngIf="item?.is_radius">
              <span *ngIf="item?.delivery_charge === 0">Free Delivery</span>
              <span *ngIf="item?.delivery_charge > 0">
                Delivery Charge <b>{{item.delivery_charge |  CustomCurrency}}</b>
              </span>
              : Up-to {{item?.maximum_delivery_area}} mile radius
            </span>
            <span *ngIf="item?.is_radius === false">
              {{item?.area_name.toUpperCase()}} {{item?.area_postcode.toUpperCase()}} -
              <span *ngIf="item?.delivery_charge > 0"> Delivery Charge <b>{{item?.delivery_charge |  CustomCurrency}}</b></span>
              <span *ngIf="item?.delivery_charge === 0"> Free Delivery</span>
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
